import api from "../../utils/api";



export const SUBSCRIPTION_ENDPOINTS = {

  benefits: "/api/users/subscription-benefits/",

  activate: "/api/users/subscription/activate/",

  checkout: "/api/users/subscription/checkout/",

  checkoutStatus: "/api/users/subscription/checkout-status/",

};



export function normalizeSubscriptionBenefits(raw) {

  if (!raw) {

    return {

      isProfessional: false,

      freeAllowance: 0,

      freeUsed: 0,

      freeRemaining: 0,

      periodStart: null,

      periodEnd: null,

      periodDays: 30,

    };

  }

  return {

    isProfessional: Boolean(raw.is_professional),

    freeAllowance: raw.free_allowance ?? 0,

    freeUsed: raw.free_used ?? 0,

    freeRemaining: raw.free_remaining ?? 0,

    periodStart: raw.period_start ?? null,

    periodEnd: raw.period_end ?? null,

    periodDays: raw.period_days ?? 30,

  };

}



export async function fetchSubscriptionBenefits() {

  const data = await api.get(SUBSCRIPTION_ENDPOINTS.benefits, { auth: true });

  return normalizeSubscriptionBenefits(data);

}



/** Dev-only when Stripe is not configured (DEBUG backend). */

export async function activateSubscription() {

  const data = await api.post(SUBSCRIPTION_ENDPOINTS.activate, {}, { auth: true });

  return normalizeSubscriptionBenefits(data);

}



/** Start Stripe Checkout for the chosen monthly plan ("basic" | "premium"). */

export async function createSubscriptionCheckout(plan = "premium") {

  return api.post(SUBSCRIPTION_ENDPOINTS.checkout, { plan }, { auth: true });

}



/** Verify payment after Stripe redirect (session_id from URL). */

export async function fetchSubscriptionCheckoutStatus(sessionId) {

  return api.post(
    SUBSCRIPTION_ENDPOINTS.checkoutStatus,
    { session_id: sessionId },
    { auth: true }
  );

}



export function formatBenefitsPeriodEnd(iso, locale) {

  if (!iso) return null;

  const d = new Date(iso);

  if (Number.isNaN(d.getTime())) return null;

  return d.toLocaleDateString(locale === "de" ? "de-DE" : "en-US", {

    day: "numeric",

    month: "long",

    year: "numeric",

  });

}


/** Real Stripe invoice history for the current user. */
export async function fetchPaymentHistory() {
  const res = await api.get("/api/users/payment-history/", { auth: true });
  return (res?.history || []).map((h) => ({
    id: h.reference,
    reference: h.reference,
    title: h.description || "Professional",
    amount: h.amount,
    currency: h.currency,
    paid: h.paid,
    status: h.status,
    // Stripe `created` is unix seconds
    createdAt: h.created ? new Date(h.created * 1000).toISOString() : null,
    invoiceUrl: h.invoice_url || null,
  }));
}
